var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwfullMood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2727_12171)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0007 19.0014C15.9717 19.0014 20.0014 14.9717 20.0014 10.0007C20.0014 5.02976 15.9717 1 11.0007 1C6.02976 1 2 5.02976 2 10.0007C2 14.9717 6.02976 19.0014 11.0007 19.0014ZM6.53065 10.593C6.53065 11.2083 6.03061 11.7084 5.41528 11.7084C4.79996 11.7084 4.29992 11.2083 4.29992 10.593C4.29992 10.5195 4.30713 10.4475 4.32154 10.3783H6.50903C6.52344 10.4475 6.53065 10.5195 6.53065 10.593ZM17.9465 10.593C17.9465 11.2083 17.4465 11.7084 16.8312 11.7084C16.2159 11.7084 15.7158 11.2083 15.7158 10.593C15.7158 10.5195 15.723 10.4475 15.7374 10.3783H17.9249C17.9393 10.4475 17.9465 10.5195 17.9465 10.593ZM11.0008 11.399C8.83931 11.399 6.78336 12.8105 6.78336 14.883C6.78336 15.2806 7.10571 15.603 7.50336 15.603C7.901 15.603 8.22336 15.2806 8.22336 14.883C8.22336 13.9033 9.30022 12.839 11.0008 12.839C12.7016 12.839 13.7782 13.9021 13.7782 14.883C13.7782 15.2806 14.1005 15.603 14.4982 15.603C14.8958 15.603 15.2182 15.2806 15.2182 14.883C15.2182 12.8088 13.1619 11.399 11.0008 11.399Z",
    fill: "#147AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2727_12171",
    x: 0,
    y: 0,
    width: 22.0015,
    height: 22.0015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2727_12171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2727_12171",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwfullMood);
export default __webpack_public_path__ + "static/media/AwfullMood.750f2196c2d13e9975cff031708f1393.svg";
export { ForwardRef as ReactComponent };